import React, { useEffect, useRef, useState } from 'react';
import useCrmEmailExport from 'api/hooks/useCrmEmailExport';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import normalize from 'components/Dashboard/utilities/normalizeString';

const fileNameByTab = {
  Recipients: 'recipients',
  Performance: 'performance',
};

function EmailPerformanceExportButton({ emailId, activeTab, emailSubject }) {
  const [isLoading, setIsLoading] = useState(false);
  const { exportRecipientsCsv, exportPerformanceCsv } = useCrmEmailExport();
  const sourceRef = useRef(null);

  useEffect(() => {
    const controller = new AbortController();
    sourceRef.current = controller;
    return () => controller.abort('Email performance export cancelled');
  }, []);

  const handleExport = async () => {
    if (!emailId || !fileNameByTab[activeTab]) return;

    setIsLoading(true);
    try {
      const blob =
        activeTab === 'Recipients'
          ? await exportRecipientsCsv({ emailId, signal: sourceRef.current?.signal })
          : await exportPerformanceCsv({ emailId, signal: sourceRef.current?.signal });

      const downloadUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', downloadUrl);
      link.setAttribute('download', `${normalize(emailSubject) || 'email'}-${fileNameByTab[activeTab]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      if (error.name !== 'CanceledError') {
        createNotification('danger', 'Unable to export right now. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='position-relative d-inline-block'>
      <button
        onClick={handleExport}
        disabled={isLoading || !emailId || !fileNameByTab[activeTab]}
        className='flex-centered general-button specific-y-padding-6 border-general transition-default px-3 rounded-pill bg-main-white border-grey action-state-hover'
        data-testid='email-performance-export-csv'
      >
        {isLoading ? <i className='fas fa-spinner fa-spin' /> : <span className='icon-download' />}
        <span className='specific-left-padding-13'>Export CSV</span>
      </button>
    </div>
  );
}

export default EmailPerformanceExportButton;
